"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumPowerPortNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const AltiumNetNamingRule_1 = require("./AltiumNetNamingRule");
const AltiumNetNameCaseSelection_1 = require("./AltiumNetNameCaseSelection");
class AltiumPowerPortNamingRule extends AltiumNetNamingRule_1.AltiumNetNamingRule {
    constructor(config, namingStrategy) {
        super(config, namingStrategy);
    }
    apply(group, _hierarchy) {
        if (!group.hasLabelType('power-port')) {
            return undefined;
        }
        const powerPortNames = [];
        const powerPortNamesByFold = new Map();
        for (const label of group.getNetLabels()) {
            if (label.labelType !== 'power-port') {
                continue;
            }
            const name = label.formattedLabel ?? label.originalLabel;
            const fold = name.toLowerCase();
            const existingName = powerPortNamesByFold.get(fold);
            if (existingName === undefined || (0, AltiumNetNameCaseSelection_1.compareAltiumNetNameCaseVariants)(name, existingName) < 0) {
                powerPortNamesByFold.set(fold, name);
            }
            powerPortNames.push(name);
        }
        if (powerPortNames.length === 0) {
            return undefined;
        }
        powerPortNames.sort((a, b) => sigma_engine_shared_1.Utils.naturalStringSort(a, b));
        return this.dereferenceLabelName(powerPortNamesByFold.get(powerPortNames[0].toLowerCase()));
    }
}
exports.AltiumPowerPortNamingRule = AltiumPowerPortNamingRule;
//# sourceMappingURL=AltiumPowerPortNamingRule.js.map